import SalesOffersBlocker from '@/app/[lng]/components/BlockerModal/SalesOffersBlocker'
import { useContactSellerSalesOfferGTMEvent } from '@/app/[lng]/components/GTMTrackers/GTMSalesOfferTracker'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { X } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import OfferContact from './OfferContact'

const OfferContactModal = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const [open, setOpen] = useState<boolean>(false)
  const [limitFlag, setLimitFlag] = useState<boolean>(true)
  const { contact, subscription, offer, isBeneficiary } = useSelector(
    (state: RootState) => state.offerData
  )
  const sendContactSellerEvent = useContactSellerSalesOfferGTMEvent()
  useEffect(() => {
    if (!open && !limitFlag && contact === 'Limit Exhausted') {
      router.push('/sales-listing')
    }
  }, [open])
  useEffect(() => {
    if (!open) {
      setLimitFlag(false)
    }
  }, [limitFlag])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="secondary"
          size="sx"
          className="mobile:w-full"
          onClick={() => {
            sendContactSellerEvent({
              companyID: Number(offer?.offer?.company?.id),
            })
          }}
        >
          {t('Contact Seller')}
        </Button>
      </DialogTrigger>
      {contact === 'Limit Exhausted' ? (
        <DialogContent
          hideCloseIcon={true}
          className="border-0 p-0 max-w-[626px] min-h-[216px] bg-[white] outline-none py-7"
          onInteractOutside={(e) => {
            e.preventDefault()
          }}
        >
          <SalesOffersBlocker
            name={subscription.name}
            limit={subscription.limit}
            isBeneficiary={isBeneficiary}
          />
        </DialogContent>
      ) : (
        <DialogContent
          hideCloseIcon={false}
          className="border-0 p-0 !max-w-[1080px] bg-[white]  max-h-[90vh]"
          onInteractOutside={(e) => {
            e.preventDefault()
          }}
        >
          <DialogHeader className="">
            <DialogTitle className="bg-modal_header text-base px-8 py-4 tracking-wide flex items-center sticky gap-8">
              {t('Seller Contact Information')}
            </DialogTitle>
          </DialogHeader>
          <div className="overflow-y-scroll max-h-[70vh] ">
            <OfferContact />
            <DialogFooter>
              <div className="flex gap-10 ">
                <Button
                  type="submit"
                  variant="grayBtn"
                  className="bg-gray_btn"
                  size="icon"
                  onClick={() => {
                    setOpen(!open)
                  }}
                >
                  <X className="h-5 w-5" />
                  {t('CANCEL')}
                </Button>
              </div>
            </DialogFooter>
          </div>
        </DialogContent>
      )}
    </Dialog>
  )
}

export default OfferContactModal
